import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Button, Form, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getUserById, updateUser } from '../../store/slices/userSlice';
import { Alert, Card, Descriptions, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, FileTextOutlined, MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons';
import { useForm } from 'antd/es/form/Form';
import { getCodes } from '../../store/slices/codeSlice';

const ViewCustomer = () => {
    const { id } = useParams();
    const [form] = useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [type, setType] = useState("user");
    const { userData } = useSelector((state) => state?.user)
    const { codes } = useSelector((state) => state?.code)
    console.log(codes)
    // console.log(userData)

    useEffect(() => {
        dispatch(getUserById(id))
        dispatch(getCodes())
    }, [dispatch, id])

    const user = userData?.data?.user

    useEffect(() => {
        if (userData?.data?.user) {
            let isVerified = null
            if (userData?.data?.user?.is_verified == 0) {
                isVerified = "Block"
            } else if (userData?.data?.user?.is_verified == 1) {
                isVerified = "UnBlock"
            }
            form.setFieldsValue({
                is_verified : isVerified
            })
        }
    }, [form, userData])

    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            let isVerified = null
            if (values?.is_verified == "Block") {
                isVerified = 0
            } else if (values?.is_verified == "UnBlock") {
                isVerified = 1
            } else {
                isVerified = userData?.data?.user?.is_verified
            }

            const resultAction = await dispatch(updateUser({
                id,
                is_verified : isVerified,
                code_id : values?.code
            }));
            setType('agent')

            if (updateUser.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Agent updated successfully!');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error updating agent');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error updating agent.');
            setAlertType('error');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Customer</h1>
            <Card
                title={
                    <span style={{ fontSize: '18px', fontWeight: 600 }}>
                        <UserOutlined style={{ marginRight: 8, color: '#CA9AE8' }} />
                        Customer Information
                    </span>
                }
                style={{
                    marginBottom: 24,
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    border: 'none',
                }}
            >
                <Descriptions column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} bordered>
                    <Descriptions.Item label={<span><UserOutlined style={{ marginRight: 4 }} />Full Name</span>}>
                        {user ? `${user.first_name} ${user.last_name}` : 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><MailOutlined style={{ marginRight: 4 }} />Email</span>}>
                        {user?.email || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><PhoneOutlined style={{ marginRight: 4 }} />Phone</span>}>
                        {user?.phone || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><FileTextOutlined style={{ marginRight: 4 }} />Gender</span>}>
                        {user?.gender || 'N/A'}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
            {/* <Card title="Edit Customer" style={{ marginBottom: 16 }}>
                {alertMessage && type == "agent" && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                >
                    <Form.Item
                        label="Block/Unblock"
                        name="is_verified"
                    >
                        <Select
                            options={[
                                { value: 'Block', label: 'Block' },
                                { value: 'UnBlock', label: 'UnBlock' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Code"
                        name="code"
                    >
                        <Select
                            options={codes?.data?.map((data) => ({
                                value : data?._id,
                                label : data?.code
                            }))}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card> */}
        </div>
    );
};

export default ViewCustomer;